import React, { Component } from 'react';
import { Card } from 'antd';

import DescriptionList from '@comm/DescriptionList';
import { queryAccountInfo } from '@api/core/user';
import { queryFilePreview } from '@api/pub/attachment';
import ModalApportion from './ModalTable';
import ModalDetailTable from './ModalDetailTable';

const { Description } = DescriptionList;
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      detailVisible: false,
    };
  }

  componentDidMount() {
    this.getLoginUser();
  }

  getLoginUser = () => {
    queryAccountInfo().then(res => {});
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleDetailVisible = flag => {
    this.setState({
      detailVisible: !!flag,
    });
  };

  /**
   * 判断当前用户是否处在流程中，及在流程中的索引
   */
  isAuditor = (loginUser, activities) => {
    let location = -1;
    activities.map((item, index) => {
      if (loginUser.userUuid === item.processor) {
        location = index;
      }
      return item;
    });
    return location;
  };

  render() {
    const { visible, detailVisible } = this.state;
    const dataItem = this.props.data;
    const files = dataItem.files || [];
    return (
      <div className="form-open">
        <Card title="年终奖详情">
          <DescriptionList size="large" col={3}>
            <Description term="年终奖金额">{dataItem.price}元</Description>
            <Description term="年终奖公司">{dataItem.company}</Description>
            <Description term="年终奖凭证">
              {files.length > 0 ? (
                <a onClick={() => queryFilePreview(files[0])}> {files[0].name}</a>
              ) : (
                ''
              )}
            </Description>
            <Description term="预算来源">
              <a onClick={() => this.handleVisible(true)}>发放详情</a>
            </Description>
            <Description term="年终奖明细">
              <a onClick={() => this.handleDetailVisible(true)}>详情</a>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="年终奖说明">{dataItem.reason}</Description>
          </DescriptionList>
        </Card>
        {visible ? (
          <ModalApportion
            onCancel={this.handleVisible}
            details={dataItem.apportion ? dataItem.apportion.details : []}
            visible={visible}
          />
        ) : null}
        {detailVisible ? (
          <ModalDetailTable
            onCancel={this.handleDetailVisible}
            visible={detailVisible}
            {...this.props}
          />
        ) : null}
      </div>
    );
  }
}

export default Open;



// WEBPACK FOOTER //
// ./src/components/hr/bonus/FormOpen.js